import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl mb-3" }, "Estimated profit", -1)
const _hoisted_2 = { class: "w-full h-96 flex items-center justify-center mt-10" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-semibold" }, "No data found for these dates", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, "Profit details", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_DetailProfit = _resolveComponent("DetailProfit")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _normalizeProps(_guardReactiveProps(_ctx.content)), {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_select, {
        placeholder: "Filter by",
        modelValue: _ctx.option,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.option) = $event)),
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateRangeOption, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.label,
              onClick: ($event: any) => (_ctx.setOptionFilter(item)),
              clearable: ""
            }, null, 8, ["label", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.dataShow.length > 0)
          ? (_openBlock(), _createBlock(_component_Chart, {
              key: 0,
              size: { width: 1200, height: 420 },
              data: _ctx.dataShow,
              margin: _ctx.margin,
              direction: _ctx.direction,
              axis: _ctx.axis
            }, {
              layers: _withCtx(() => [
                _createVNode(_component_Grid, { strokeDasharray: "2,2" }),
                _createVNode(_component_Bar, {
                  dataKeys: ['day', 'profit'],
                  barStyle: { fill: '#99d98c', },
                  maxWidth: "50"
                }),
                _createVNode(_component_Bar, {
                  dataKeys: ['day', 'estimatedProfit'],
                  barStyle: { fill: '#52b69a ' },
                  maxWidth: "50"
                })
              ]),
              widgets: _withCtx(() => [
                _createVNode(_component_Tooltip, {
                  borderColor: "#0096c7",
                  config: {
            profit: { color: '#99d98c' },
            estimatedProfit: { color: '#52b69a' },
          }
                })
              ]),
              _: 1
            }, 8, ["data", "margin", "direction", "axis"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createVNode(_component_DetailProfit, {
          "start-date": _ctx.params.startDate,
          "end-date": _ctx.params.endDate
        }, null, 8, ["start-date", "end-date"])
      ])
    ]),
    _: 1
  }, 16))
}